var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.38,10.53A6.33,6.33,0,0,0,24.12,5.3h0A6.33,6.33,0,0,0,19.4,8.86H12.6A6.33,6.33,0,0,0,7.88,5.3h0A6.33,6.33,0,0,0,.62,10.53C.41,14.6-.31,19,.15,23.06a6.93,6.93,0,0,0,1.29,3.47,4.6,4.6,0,0,0,2.74,1.65,4.53,4.53,0,0,0,3.11-.7,6.79,6.79,0,0,0,2.32-2.89c.24-.51.46-1.05.66-1.59A4.58,4.58,0,0,0,14,20.61h4A4.58,4.58,0,0,0,21.73,23c.2.54.42,1.08.66,1.59a6.79,6.79,0,0,0,2.32,2.89,4.53,4.53,0,0,0,3.11.7,4.6,4.6,0,0,0,2.74-1.65,6.93,6.93,0,0,0,1.29-3.47C32.31,19,31.59,14.6,31.38,10.53Z",
    fill: "#2d4a60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,21a2.62,2.62,0,1,1,2.63-2.62A2.62,2.62,0,0,1,10,21Z",
    fill: "#7b8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76,18.6a1,1,0,1,1,1-1A1,1,0,0,1,10.76,18.6Z",
    fill: "#8fa5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21a2.62,2.62,0,1,1,2.62-2.62A2.62,2.62,0,0,1,22,21Z",
    fill: "#7b8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.84,18.6a1,1,0,1,1,1-1A1,1,0,0,1,22.84,18.6Z",
    fill: "#8fa5a5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 14.05,
    width: 3,
    height: 2,
    rx: 0.77,
    fill: "#eaeff0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 14.05,
    width: 3,
    height: 2,
    rx: 0.77,
    fill: "#eaeff0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,10.86h-1v-1a1,1,0,0,0-2,0v1h-1a1,1,0,1,0,0,2h1v1a1,1,0,0,0,2,0v-1h1a1,1,0,1,0,0-2Z",
    fill: "#eaeff0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,10.66v-1A1,1,0,0,1,6,9.07a1,1,0,0,0-.41.79v.8Z",
    fill: "#bac2c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,14.66a1,1,0,0,1-1-1v-1h-1a1,1,0,0,1-1-1A1,1,0,0,1,4,11.07a1,1,0,0,0-.41.79,1,1,0,0,0,1,1h1v1a1,1,0,0,0,1,1,1,1,0,0,0,.79-.42A1,1,0,0,1,6.8,14.66Z",
    fill: "#bac2c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8,12.66h-1v.2h.8a1,1,0,0,0,.79-.42A1,1,0,0,1,8.8,12.66Z",
    fill: "#bac2c6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.4,
    cy: 9.86,
    r: 1,
    fill: "#00cf66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,10.66a1,1,0,0,1-1-1,1,1,0,0,1,.21-.59,1,1,0,0,0-.41.79,1,1,0,0,0,1,1,1,1,0,0,0,.79-.42A1,1,0,0,1,25.6,10.66Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.4,
    cy: 13.86,
    r: 1,
    fill: "#009ae0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,14.66a1,1,0,0,1-1-1,1,1,0,0,1,.21-.59,1,1,0,0,0-.41.79,1,1,0,0,0,1,1,1,1,0,0,0,.79-.42A1,1,0,0,1,25.6,14.66Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 23.4,
    cy: 11.86,
    r: 1,
    fill: "#fac100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6,12.66a1,1,0,0,1-1-1,1,1,0,0,1,.21-.59,1,1,0,0,0-.41.79,1,1,0,0,0,1,1,1,1,0,0,0,.79-.42A1,1,0,0,1,23.6,12.66Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 27.4,
    cy: 11.86,
    r: 1,
    fill: "#fd3730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,12.66a1,1,0,0,1-1-1,1,1,0,0,1,.21-.59,1,1,0,0,0-.41.79,1,1,0,0,0,1,1,1,1,0,0,0,.79-.42A1,1,0,0,1,27.6,12.66Z",
    opacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.fdfef4a12c45ca38772ce35eac82bc0f.svg";
export { ForwardRef as ReactComponent };